<script setup lang="ts">

</script>

<template>
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.847656 5.24837C0.847656 5.24837 3.04753 0.848633 6.8973 0.848633C10.7471
      0.848633 12.9469 5.24837 12.9469 5.24837C12.9469 5.24837 10.7471 9.64811
      6.8973 9.64811C3.04753 9.64811 0.847656 5.24837 0.847656 5.24837Z"
      stroke="currentColor"
      stroke-width="1.69704"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.8973 6.89828C7.80851 6.89828 8.5472 6.15959 8.5472 5.24837C8.5472
      4.33716 7.80851 3.59847 6.8973 3.59847C5.98608 3.59847 5.2474 4.33716
      5.2474 5.24837C5.2474 6.15959 5.98608 6.89828 6.8973 6.89828Z"
      stroke="currentColor"
      stroke-width="1.69704"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>